import React, { useState, useEffect, useRef } from 'react';
import { useKeycloak } from '@react-keycloak/web';

const sidebarItems = [
    'Modifier le profil',
    'Gestion de votre compte'
];

export default function SettingsPage() {
    const [account, setAccount] = useState({
        birthdate: '',
        gender: 'Homme',
        country: 'France',
        language: 'fr',
        is_pro: 0 // ⬅️ ajouté
    });

    const { keycloak } = useKeycloak();
    const token = keycloak.token;
    const avatarInputRef = useRef();
    const coverInputRef = useRef();
    const [message, setMessage] = useState('');
    const [variant, setVariant] = useState(''); // 'success' | 'danger'
    const [active, setActive] = useState('Modifier le profil');
    const [settings, setSettings] = useState({
        emailNotif: false,
        pushNotif: false,
        darkMode: false,
        language: 'fr',
        timezone: 'America/New_York'
    });

    const tooltipRef = useRef(null);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage('');
                setVariant('');
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    useEffect(() => {
        if (!token) return;

        fetch("https://www.weavevo.com/settings", {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(res => res.json())
            .then(data => {
                setSettings({
                    emailNotif: data.email_notifications === 1,
                    pushNotif: data.push_notifications === 1,
                    darkMode: data.dark_mode === 1,
                    language: data.language || 'fr',
                    timezone: data.timezone || 'America/New_York'
                });
            })
            .catch(console.error);
    }, [token]);

    useEffect(() => {
        if (!token) return;
        fetch("https://www.weavevo.com/settingAccount", {
            headers: { Authorization: `Bearer ${token}` }
            
        })
            .then(res => res.json())
            .then(data => {
                setAccount({
                    birthdate: data.birthdate || '',
                    gender: data.gender || 'Homme',
                    country: data.country || 'France',
                    language: data.language || 'fr'
                });
            })
            .catch(console.error);
    }, [token]);

    const handleAccountSave = () => {
        fetch("https://www.weavevo.com/settingAccount", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(account)
        })
            .then(res => {
                if (res.ok) {
                    setMessage("✅ Compte mis à jour !");
                    setVariant("success");
                } else {
                    setMessage("❌ Erreur lors de la mise à jour.");
                    setVariant("danger");
                }
            })
            .catch(err => {
                console.error(err);
                setMessage("⚠️ Erreur réseau.");
                setVariant("danger");
            });
    };

    const handleSave = () => {
        if (!token) return;

        const payload = {
            email_notifications: settings.emailNotif ? 1 : 0,
            push_notifications: settings.pushNotif ? 1 : 0,
            dark_mode: settings.darkMode ? 1 : 0,
            language: settings.language,
            timezone: settings.timezone
        };

        fetch("https://www.weavevo.com/settings", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.ok) {
                    setMessage("Paramètres enregistrés avec succès ");
                    setVariant("success");
                } else {
                    setMessage(" Une erreur est survenue lors de l'enregistrement.");
                    setVariant("danger");
                }
            })
            .catch(err => {
                console.error("Erreur:", err);
                setMessage("⚠️ Erreur réseau.");
                setVariant("danger");
            });
    };

   return (
  <div className="container py-5">
    {message && (
      <div
        ref={tooltipRef}
        className={`alert alert-${variant}`}
        style={{
          position: 'fixed',
          top: '80px',
          right: '20px',
          zIndex: 9999,
          maxWidth: '300px',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          padding: '12px'
        }}
      >
        {message}
      </div>
    )}

    {/* MENU HORIZONTAL */}
    <div className="d-flex justify-content-center mb-4 gap-3 border-bottom pb-2" style={{ paddingTop: '20px'}}>
      {sidebarItems.map((item, index) => (
        <button
          key={index}
          className={`btn ${
            active === item ? 'btn-dark' : 'btn-outline-secondary'
          } rounded-pill px-4`}
          onClick={() => setActive(item)}
        >
          {item}
        </button>
      ))}
    </div>

    {/* CONTENU */}
    <div className="row justify-content-center" >
      <div className="col-lg-8">
        {active === 'Modifier le profil' && (
          <>
            <h2 className="mb-4">Paramètres</h2>
            <div className="form-check mb-3">
              <input className="form-check-input" type="checkbox" checked={settings.emailNotif}
                onChange={() => setSettings(prev => ({ ...prev, emailNotif: !prev.emailNotif }))} id="emailNotif" />
              <label className="form-check-label" htmlFor="emailNotif">Notifications par email</label>
            </div>
            <div className="form-check mb-3">
              <input className="form-check-input" type="checkbox" checked={settings.pushNotif}
                onChange={() => setSettings(prev => ({ ...prev, pushNotif: !prev.pushNotif }))} id="pushNotif" />
              <label className="form-check-label" htmlFor="pushNotif">Notifications push</label>
            </div>
            <div className="form-check mb-3">
              <input className="form-check-input" type="checkbox" checked={settings.darkMode}
                onChange={() => setSettings(prev => ({ ...prev, darkMode: !prev.darkMode }))} id="darkMode" />
              <label className="form-check-label" htmlFor="darkMode">Mode sombre</label>
            </div>
            <div className="mb-3">
              <label className="form-label">Langue</label>
              <select className="form-select" value={settings.language}
                onChange={e => setSettings(prev => ({ ...prev, language: e.target.value }))}>
                <option value="fr">Français</option>
                <option value="en">English</option>
                <option value="ar">العربية</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="form-label">Fuseau horaire</label>
              <select className="form-select" value={settings.timezone}
                onChange={e => setSettings(prev => ({ ...prev, timezone: e.target.value }))}>
                <option value="Europe/Paris">Europe/Paris</option>
                <option value="America/New_York">Amérique/New York</option>
                <option value="Asia/Tokyo">Asie/Tokyo</option>
              </select>
            </div>
            <button className="btn btn-primary" onClick={handleSave}>Sauvegarder</button>
          </>
        )}

        {active === 'Gestion de votre compte' && (
          <>
            <h2 className="mb-4">Votre compte</h2>
            <div className="mb-3">
              <label className="form-label">Adresse e-mail</label>
              <input type="email" className="form-control" value="akremanaya@gmail.com" disabled />
            </div>
            <div className="mb-3">
              <label className="form-label">Mot de passe</label>
              <div className="d-flex align-items-center">
                <input type="password" className="form-control me-2" value="********" disabled />
                <button className="btn btn-secondary">Modifier</button>
              </div>
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="proCheck"
                checked={account.is_pro === 1}
                onChange={() => setAccount(prev => ({ ...prev, is_pro: prev.is_pro === 1 ? 0 : 1 }))}
              />
              <label className="form-check-label" htmlFor="proCheck">
                Compte professionnel
              </label>
            </div>
            <div className="mb-5">
              <label className="form-label">Passez à un compte professionnel</label>
              <p className="text-muted">Avec un compte professionnel, vous aurez accès à des outils tels que les annonces et les statistiques pour développer votre activité.</p>
              <button className="btn btn-outline-dark">Convertir le compte</button>
            </div>
            <h5 className="mb-3">Informations personnelles</h5>
            <div className="mb-3">
              <label className="form-label">Date de naissance</label>
              <input type="date" className="form-control" value={account.birthdate}
                onChange={e => setAccount(prev => ({ ...prev, birthdate: e.target.value }))} />
            </div>
            <div className="mb-3">
              <label className="form-label">Identité de genre</label>
              <div>
                {["Homme", "Femme"].map((option) => (
                  <div className="form-check form-check-inline" key={option}>
                    <input className="form-check-input" type="radio" name="gender" id={`gender-${option}`} value={option}
                      checked={account.gender === option}
                      onChange={e => setAccount(prev => ({ ...prev, gender: e.target.value }))} />
                    <label className="form-check-label" htmlFor={`gender-${option}`}>{option}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Pays/Région</label>
              <select className="form-select" value={account.country}
                onChange={e => setAccount(prev => ({ ...prev, country: e.target.value }))}>
                <option value="France">France</option>
                <option value="Tunisie">Tunisie</option>
                <option value="Canada">Canada</option>
                <option value="États-Unis">États-Unis</option>
                <option value="Allemagne">Allemagne</option>
              </select>
            </div>
            <button className="btn btn-primary mt-3" onClick={handleAccountSave}>
              Sauvegarder les infos du compte
            </button>
            <h5 className="mb-3 mt-5">Désactivation et suppression</h5>
            <div className="mb-3">
              <p className="text-muted">Masquez temporairement votre profil ou désactivez votre compte.</p>
              <button className="btn btn-outline-danger">Désactiver le compte</button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

}
